let consoleCallbacks = [
	'warn', 'log', 'info', 'error', 'assert',
	'dir', 'table', 'group', 'groupEnd', 'time',
	'timeEnd', 'timeLog', 'trace', 'clear', 'count',
	'debug', 'dirxml', 'groupCollapsed',
];

if (!window.console) {
	window.console = {}
}

for (let callback of consoleCallbacks) {
	if (!window.console[callback]) {
		window.console[callback] = function () {
			return this
		}
	}
}

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '../node_modules/bootstrap/dist/css/bootstrap.css'
import '../node_modules/animate.css/animate.min.css'
import NoDragImage from '@/components/common/NoDragImage'
import VueCookies from 'vue-cookies'

Vue.config.productionTip = false

Vue.component('no-drag-image', NoDragImage)

require('@/utils/consoleBadges').logAppInfo()

Vue.use(VueCookies)

// set default config
Vue.$cookies.config('7d')

new Vue({
	router,
	store,
	render: h => h(App),
}).$mount('#app')
